import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import HelpSupportPage from './pages/HelpSupportPage';
import { LATEST_PRIVACY_POLICY_VERSION } from './config/privacyPolicy';
import { LATEST_TERMS_OF_USE_VERSION } from './config/termsOfUse';
import './App.css';

function App() {
    return (
        <div className="App">
            <Header />
            <main>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                        path="/privacy-policy"
                        element={
                            <Navigate
                                to={`/privacy-policy/v/${LATEST_PRIVACY_POLICY_VERSION}`}
                                replace
                            />
                        }
                    />
                    <Route path="/privacy-policy/v/:version" element={<PrivacyPolicyPage />} />
                    <Route
                        path="/terms-of-use"
                        element={
                            <Navigate
                                to={`/terms-of-use/v/${LATEST_TERMS_OF_USE_VERSION}`}
                                replace
                            />
                        }
                    />
                    <Route path="/terms-of-use/v/:version" element={<TermsOfUsePage />} />
                    <Route path="/help-support" element={<HelpSupportPage />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default App;
